import { View } from "react-native"
import { useWatch, Control } from "react-hook-form"

import { purchaseTransactionFormSchema } from "@white-labels/input/src/m5azen"
import { z } from "@white-labels/input"

import { ar } from "@src/i18n/ar"
import { Text } from "@src/components/core"
import { priceFromDBFormat } from "@src/utils"

export function TransactionSummary({ control }: { control: Control<z.infer<typeof purchaseTransactionFormSchema>> }) {
  const products = useWatch({ control, name: "products", defaultValue: [] })
  const discount = useWatch({ control, name: "discount" })

  // discount is now stored in milli-units as a number
  const discountValue = Number(discount) || 0
  const subTotal = products?.reduce((acc, product) => acc + Number(product.cost ?? 0) * product.quantity, 0)
  const total = subTotal - discountValue

  return (
    <View className="bg-white rounded p-4 mb-4">
      <Text className="text-lg font-bold text-gray-800 mb-3">{ar.summary}</Text>

      <View className="space-y-2">
        <View className="flex-row justify-between mb-2">
          <Text className="text-gray-600">{ar.subTotal}</Text>
          <Text className="font-medium">EGP {priceFromDBFormat(subTotal).toFixed(2)}</Text>
        </View>

        {discountValue > 0 && (
          <View className="flex-row justify-between mb-2">
            <Text className="text-gray-600">{ar.discount}</Text>
            <Text className="font-medium text-red-600">EGP {priceFromDBFormat(discountValue).toFixed(2)}</Text>
          </View>
        )}

        <View className="flex-row justify-between pt-2 border-t border-gray-200">
          <Text className="text-lg font-bold text-gray-800">{ar.total}:</Text>
          <Text className="text-lg font-bold text-green-600">EGP {priceFromDBFormat(total).toFixed(2)}</Text>
        </View>
      </View>
    </View>
  )
}
